"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_Badge = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_Badge = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    padding: 5px;\n    border-radius: var(--border-radius-xs);\n    margin: var(--spacing-none);\n    background-color: ", ";\n    display: flex;\n    max-width: fit-content;\n    align-items: center;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n        background-color: ", ";\n    }\n"])), function (props) {
  if (props.color === 'secondary') {
    return 'var(--color-secondary)';
  } else if (props.color === 'red') {
    return 'var(--color-red-600)';
  } else if (props.color === 'disabled') {
    return 'var(--color-gray-400)';
  } else {
    return 'var(--color-primary)';
  }
}, function (props) {
  if (props.color === 'secondary') {
    return 'var(--color-secondary-highlight)';
  } else {
    return 'var(--color-primary-highlight)';
  }
});
exports.Occ_Badge = Occ_Badge;